export type QuoteLang = "cn" | "jp" | "kr" | "en";

export const quoteLangs: { id: QuoteLang; label: string }[] = [
  { id: "en", label: "English" },
  { id: "jp", label: "日本語" },
  { id: "cn", label: "中文" },
  { id: "kr", label: "한국어" },
];

export type QuoteLine = {
  key: string;
  label: string;
  text: Record<QuoteLang, string>;
  voice?: Partial<Record<QuoteLang, string>>;
};

export const quotes: QuoteLine[] = [
  {
    "key": "GAIN",
    "label": "Acquisition",
    "text": {
      "cn": "长官，蒙德拉贡前来报到，有什么需要我执行的任务请交给我。",
      "jp": "初めまして、指揮官様。モンドラゴンM1908と申します。御用がありましたら、なんなりとお申し付けください。",
      "kr": "처음 뵙겠습니다, 지휘관님. 몬드라곤 M1908이라고 합니다. 필요한 일이 있다면 얼마든지 말씀해 주십시오.",
      "en": "Mondragón reporting, Commander. Please assign me any missions which need to be carried out."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_GAIN_JP.ogg"
    }
  },
  {
    "key": "DIALOGUE1",
    "label": "Secretary I",
    "text": {
      "cn": "长官，叫我蒙德就好。请不要叫我“拉贡”……听见这个称呼会让我难过。",
      "jp": "指揮官様、どうか私のことはモンドと御呼び下さい。「ラゴン」では、その……いささか抵抗がありますので……",
      "kr": "지휘관님, 저는 \"몬드\"라고 불러주시길 바랍니다. \"라곤\"은... 좀 저촉되는 일이 있어서.",
      "en": "Commander, please call me \"Mond\", and not \"Ragon\"...That form of address upsets me."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_DIALOGUE1_JP.ogg"
    }
  },
  {
    "key": "DIALOGUE2",
    "label": "Secretary II",
    "text": {
      "cn": "抱歉，长官，我并不是喜欢闲聊的人形。不同于那些能通过聊天获取能量的人形，每一次无关任务的交谈，只会让我额外损耗部分能源。",
      "jp": "指揮官様、申し訳ございません。私は雑談があまり好きではないのです。おしゃべりすることで元気になる人形たちとは違い、任務と関わりのない話をすると、余計に疲れてしまうのです。",
      "kr": "죄송합니다, 지휘관님. 저는 잡담을 좋아하지 않습니다, 대화로 기운이 좋아지는 인형과는 달리, 전 임무와 관계 없는 이야기를 하면 오히려 피곤해집니다.",
      "en": "My apologies, Commander, but I am not given to idle conversation. Unlike those Dolls who gain strength by chatting, every interaction that is not related to the mission only causes me to expend unnecessary energy."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_DIALOGUE2_JP.ogg"
    }
  },
  {
    "key": "DIALOGUE3",
    "label": "Secretary III",
    "text": {
      "cn": "曾经，我有一位很强大的朋友，强大到可以让我放心依赖。但却因为一个再小不过的失误，让她永远也无法回到我的身边……",
      "jp": "かつて、私には頼りになる強い友人がいました。しかし、ほんの些細なミスによって、彼女が私の側に戻ってくることは二度とありませんでした……",
      "kr": "이전에, 제겐 매우 듬직한 강한 벗이 있었습니다. 하지만 아주 사소한 실수로 그녀는 다신 제 곁에 돌아올 수 없게 되었습니다...",
      "en": "Once, I had a strong friend, so strong that I could allow myself to rely on her without any doubts in my heart. But now, due to a tiny, insignificant mistake, she can never return to my side..."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_DIALOGUE3_JP.ogg"
    }
  },
  {
    "key": "DIALOGUEWEDDING",
    "label": "Secretary (oath)",
    "text": {
      "cn": "长官，您知道的，我会一直在门外。只要您需要我，我随时准备为您做任何事。",
      "jp": "指揮官様、私は外で待機してますね。何か御用がありましたら、いつでも御呼び下さい。",
      "kr": "지휘관님, 전 밖에서 상시 대기 중이니, 용무가 있다면 언제든지 불러주십시오.",
      "en": "Commander, you know I will always be outside your door. If you need me, I am ready to do anything for you at any time."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_DIALOGUEWEDDING_JP.ogg"
    }
  },
  {
    "key": "SOULCONTRACT",
    "label": "Oath",
    "text": {
      "cn": "……这倒是我从未想过的馈赠，长官。 感谢您一直以来对我的认可和信任，也感谢您为我许下这样沉重的誓言。 虽然未来对我来说依旧是虚无缥缈之物，但是握着您给予的承诺，我便不会再感到畏惧。",
      "jp": "……思ってもいなかった贈り物です、指揮官様。 貴方が私をずっと信頼してくださったこと、そしてこのような誓いをくださったこと、本当に感謝しています。 未来のことは分かりませんが、貴方との約束があれば、私はもう恐れることはないでしょう。",
      "kr": "이런 선물을 받을 줄은 예상 못했습니다, 지휘관님. 항상 저를 인정하고 믿어주시고, 또 이런 맹세를 맺어주셔서 대단히 감사합니다. 미래는 여전히 알 수 없지만, 지휘관님의 맹세가 있는 한, 제게 두려운 일은 없습니다.",
      "en": "...I did not expect a gift like this, Commander. Thank you for always acknowledging and trusting in me, and thank you for making such a solemn pledge with me. Although the future remains an uncertain and illusory thing, I will no longer fear it now that I hold the promise that you have given me."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_SOULCONTRACT_JP.ogg"
    }
  },
  {
    "key": "HELLO",
    "label": "Greeting",
    "text": {
      "cn": "报告长官，今天的基地一切正常。",
      "jp": "指揮官様、本日も基地に異常はありません。",
      "kr": "지휘관님, 오늘도 기지에 이상 없습니다.",
      "en": "Commander, the situation in the base today is normal."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_HELLO_JP.ogg"
    }
  },
  {
    "key": "BUILDOVER",
    "label": "T-Doll produced",
    "text": {
      "cn": "是新人，我会立刻对她进行全面的行为观察分析。",
      "jp": "新人さんですか。では、すぐ分析に取り掛からせていただきます。",
      "kr": "신입입니까? 그럼 즉시 분석에 착수하겠습니다.",
      "en": "We have a new arrival. I will immediately perform a full inspection and analysis on her."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_BUILDOVER_JP.ogg"
    }
  },
  {
    "key": "FORMATION",
    "label": "Joining an echelon",
    "text": {
      "cn": "请保持肃静，听从我的指示。",
      "jp": "どうかご静粛に。私の指示に従ってください。",
      "kr": "부디 정숙하고 제 지시에 따르십시오.",
      "en": "Please remain silent and listen to my instructions."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_FORMATION_JP.ogg"
    }
  },
  {
    "key": "FEED",
    "label": "Enhancement",
    "text": {
      "cn": "各方面的数值都有了显著提升，感谢您的信任，长官。",
      "jp": "各数値の大幅な上昇を確認。指揮官様、私を信頼してくださり、ありがとうございます。",
      "kr": "각 수치가 대폭 상승함을 확인. 지휘관, 절 신임하여 감사드립니다.",
      "en": "My statistics in all areas are showing a distinct improvement. Thank you for your trust, Commander."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_FEED_JP.ogg"
    }
  },
  {
    "key": "COMBINE",
    "label": "Dummy-linking",
    "text": {
      "cn": "作战效率又能得到突破了，感谢长官。",
      "jp": "作戦効率がまた上がりました。ありがとうございます、指揮官様。",
      "kr": "작전 효율이 또 상승했습니다. 감사합니다, 지휘관님.",
      "en": "I've made a new breakthrough in combat efficiency. Thank you, Commander."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_COMBINE_JP.ogg"
    }
  },
  {
    "key": "OPERATIONBEGIN",
    "label": "Logistics start",
    "text": {
      "cn": "向着远方出发。",
      "jp": "より、遠くへ。",
      "kr": "더 먼 곳으로.",
      "en": "We are setting out toward the distance."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_OPERATIONBEGIN_JP.ogg"
    }
  },
  {
    "key": "OPERATIONOVER",
    "label": "Logistics end",
    "text": {
      "cn": "蒙德拉贡，归队。",
      "jp": "モンドラゴン、ただ今戻りました。",
      "kr": "몬드라곤, 지금 복귀했습니다.",
      "en": "Mondragón, returning to unit."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_OPERATIONOVER_JP.ogg"
    }
  },
  {
    "key": "BLACKACTION",
    "label": "Autobattle",
    "text": {
      "cn": "轻松的任务罢了，无需担心。",
      "jp": "心配なさらないでください、簡単な任務ですので。",
      "kr": "걱정할 것 없습니다. 간단한 임무니까요.",
      "en": "This is a simple mission. There is no need to worry."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_BLACKACTION_JP.ogg"
    }
  },
  {
    "key": "GOATTACK",
    "label": "Combat mission",
    "text": {
      "cn": "战斗吧，为了拥抱明天。",
      "jp": "戦いましょう、明日を掴み取るために。",
      "kr": "싸웁시다, 내일을 거머쥐기 위해서.",
      "en": "Fight hard so you may embrace tomorrow."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_GOATTACK_JP.ogg"
    }
  },
  {
    "key": "MEET",
    "label": "Battle start",
    "text": {
      "cn": "抱歉，要从你们的身上剥夺走生命的气息了。",
      "jp": "その命、頂戴致します。悪く思わないで下さい。",
      "kr": "그 목숨을 가져가겠습니다, 원망하지 마십시오.",
      "en": "Forgive me, but I shall be taking your life now."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_MEET_JP.ogg"
    }
  },
  {
    "key": "SKILL1",
    "label": "Skill I",
    "text": {
      "cn": "我会让你毫无痛苦地离开……",
      "jp": "痛みもなく、逝かせてあげましょう。",
      "kr": "고통 없이 보내드리죠...",
      "en": "I will dispatch you painlessly."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_SKILL1_JP.ogg"
    }
  },
  {
    "key": "SKILL2",
    "label": "Skill II",
    "text": {
      "cn": "请放弃徒劳的挣扎。",
      "jp": "無駄な足搔きです。",
      "kr": "괜한 몸부림입니다.",
      "en": "Abandon your pointless struggles."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_SKILL2_JP.ogg"
    }
  },
  {
    "key": "SKILL3",
    "label": "Skill III",
    "text": {
      "cn": "让我为你合上双眼。",
      "jp": "お眠りください、永遠に。",
      "kr": "그만 주무십시오, 영원히.",
      "en": "Allow me to close your eyes."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_SKILL3_JP.ogg"
    }
  },
  {
    "key": "BREAK",
    "label": "Heavily damaged",
    "text": {
      "cn": "不要管我，继续战斗。",
      "jp": "私に構わず、攻撃を続けてください。",
      "kr": "저는 신경쓰지 말고 계속 공격하십시오.",
      "en": "Never mind me, keep fighting."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_BREAK_JP.ogg"
    }
  },
  {
    "key": "RETREAT",
    "label": "Retreat",
    "text": {
      "cn": "不要留恋战场。",
      "jp": "戦場に、未練を残してはなりません。",
      "kr": "전장에 미련을 가져선 안 됩니다.",
      "en": "Do not lose yourself in battle."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_RETREAT_JP.ogg"
    }
  },
  {
    "key": "WIN",
    "label": "MVP",
    "text": {
      "cn": "我们的胜利属于长官。",
      "jp": "私たちの勝利は、指揮官様のものです。",
      "kr": "우리의 승리는 지휘관님의 것입니다.",
      "en": "Our victory belongs to the Commander."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_WIN_JP.ogg"
    }
  },
  {
    "key": "FIX",
    "label": "Restoration",
    "text": {
      "cn": "可以稍稍休息一下了吗……",
      "jp": "少し……休憩を頂いてもよろしいですか？",
      "kr": "잠시 쉬어도 괜찮겠습니까...?",
      "en": "Can I rest a little now..."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_FIX_JP.ogg"
    }
  },
  {
    "key": "ATTACK",
    "label": "Attack",
    "text": {
      "cn": "扼住敌人的咽喉。",
      "jp": "息の根を止めてやりましょう。",
      "kr": "숨통을 끊읍시다.",
      "en": "Seize the enemy by the throat."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_ATTACK_JP.ogg"
    }
  },
  {
    "key": "DEFENSE",
    "label": "Defense",
    "text": {
      "cn": "不要迷失在这漫天殷红中。",
      "jp": "赤く染められた空に、惑わされないでください。",
      "kr": "붉게 물든 하늘에 미혹되지 마십시오",
      "en": "Do not get lost in the crimson darkness that fills the sky."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_DEFENSE_JP.ogg"
    }
  },
  {
    "key": "PHRASE",
    "label": "Phrase",
    "text": {
      "cn": "关于你的作战弱点……",
      "jp": "貴方の欠点ですが……",
      "kr": "당신의 결함에 대해서...",
      "en": "Regarding your operational flaws..."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_PHRASE_JP.ogg"
    }
  },
  {
    "key": "TIP",
    "label": "Tip",
    "text": {
      "cn": "要讨论任务吗？那请说吧。",
      "jp": "任務についてですか？ではお話致しましょう。",
      "kr": "임무에 관한 일입니까? 그럼 얘기 하시죠.",
      "en": "Do you wish to discuss the mission? By all means, then."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_TIP_JP.ogg"
    }
  },
  {
    "key": "LOADING",
    "label": "Loading",
    "text": {
      "cn": "长官，早上好。今天的安排是……",
      "jp": "おはようございます、指揮官様。本日のスケジュールですが…",
      "kr": "안녕하십니까, 지휘관님. 오늘의 스케줄에 관해서 말입니다만...",
      "en": "Good morning, Commander. Today's schedule is..."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_LOADING_JP.ogg"
    }
  },
  {
    "key": "ALLHALLOWS",
    "label": "Halloween",
    "text": {
      "cn": "该做的每日练习好好完成了吗？别以为戴上面具，我就认不出你们来了。",
      "jp": "本日の日課はちゃんと終わらせましたか？仮面を付けたところで、私には隠せませんよ。",
      "kr": "오늘 일과는 마쳤습니까? 가면을 썼다해도 절 속일 순 없습니다.",
      "en": "Have you finished your daily practice? Don't think I can't recognize you when you have your masks on."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_ALLHALLOWS_JP.ogg"
    }
  },
  {
    "key": "CHRISTMAS",
    "label": "Christmas",
    "text": {
      "cn": "圣诞节快乐，长官。那些对圣诞老人进行恶作剧的孩子已经被我罚去扫雪了，请您不要心软。",
      "jp": "メリークリスマス、指揮官様。サンタさんにいたずらした悪い子たちは庭の雪掻きに行かせました。あまりあの子たちを甘やかさないでくださいね。",
      "kr": "메리 크리스마스, 지휘관님. 산타에게 장난치는 애들은 벌로 제설하게 했습니다. 그들을 너무 봐주지 마십시오.",
      "en": "Merry Christmas, Commander. I have punished the girls who played pranks on Santa by assigning them to shovel snow. Please do not go easy on them."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_CHRISTMAS_JP.ogg"
    }
  },
  {
    "key": "NEWYEAR",
    "label": "New Year",
    "text": {
      "cn": "长官，新年好。新年期间的轮岗安排我已经放在您的桌子上了。",
      "jp": "指揮官様、明けましておめでとうございます。お正月期間中のシフトでしたら、デスクの上に置いておきました。",
      "kr": "지휘관님, 새해 축하드립니다. 새해의 근무일정표는 탁상 위에 올려놨습니다.",
      "en": "Happy New Year, Commander. The sentry rotations for the new year are already on your desk."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_NEWYEAR_JP.ogg"
    }
  },
  {
    "key": "VALENTINE",
    "label": "Valentine's",
    "text": {
      "cn": "报告长官，那些食用后可能造成中毒的巧克力已经被我处理掉了，请尽情享用剩下的美味。",
      "jp": "食べたらお腹を壊す可能性のあるチョコレートは、私がすべて廃棄しておきました。残りのものをどうぞお召し上がりください。",
      "kr": "배가 상할 수 있는 초콜릿은 제가 전부 폐기했습니다. 나머지는 맛있게 드셔주십시오.",
      "en": "Commander, the chocolates which might cause food poisoning when ingested have already been removed. Please enjoy the ones which remain."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_VALENTINE_JP.ogg"
    }
  },
  {
    "key": "TANABATA",
    "label": "Tanabata",
    "text": {
      "cn": "公然违背仙界的条理和凡人恋爱，确实该罚。不过每年还能见一次面，真是罚得太轻了。",
      "jp": "天の掟を破ってまでただの人間と恋をする。そんなの、罰せられて当然です。なのに年に一度会えるとは……処罰が軽すぎます。",
      "kr": "하늘의 규칙을 깨면서까지 사람과 연애했으니, 벌 받아 마땅합니다. 그런데 일 년에 한 번 만날 수 있다니, 처벌이 너무 약하군요.",
      "en": "Violating the laws of the celestial realm and falling in love with a mortal deserves punishment. However, allowing them to meet once a year is too light of a punishment."
    },
    "voice": {
      "jp": "/assets/voice/mondragon/MondragonM1908_TANABATA_JP.ogg"
    }
  }
];
